import styled from 'styled-components';
import { colors } from '@/styles';

export const Cell = styled.div`
  .eval-processing {
    display: flex;
    gap: 5px;
    align-items: center;
    color: ${colors.secondary.mediumGray};
  }
`;

export const Details = styled.div`
  pre {
    border-radius: 5px;
    margin: 0;
  }
  span.null-value {
    color: ${colors.secondary.lightGray3};
  }
  .eval-processing {
    display: flex;
    gap: 5px;
    align-items: center;
    color: ${colors.secondary.mediumGray};
  }
`;

export const Header = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  .header-cell-name {
    flex: 1;
  }
  .header-cell-sort {
    flex: 0;
  }
`;
